var _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCartAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H4.21922C4.45691 3 4.57575 3 4.67989 3.02244C4.97866 3.08683 5.23157 3.2843 5.3665 3.55853C5.41353 3.65411 5.44235 3.76941 5.5 4L5.6362 4.54479C5.85001 5.40003 6.61844 6 7.5 6V6",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.75H5.66318C5.09094 12.75 4.68687 12.1894 4.86783 11.6465V11.6465C5.09606 10.9618 5.73681 10.5 6.45853 10.5H10.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5139 10.5H7.69425C6.71658 10.5 5.8822 9.79317 5.72147 8.8288L5.5411 7.7466C5.38872 6.8323 6.09378 6 7.02069 6H13.382C14.1253 6 14.6088 6.78231 14.2764 7.44721L13.3028 9.39443C12.964 10.072 12.2715 10.5 11.5139 10.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.75,
    cy: 15,
    r: 0.75,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 15,
    r: 0.75,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartAlt);
export default __webpack_public_path__ + "static/media/shopping-cart-alt.d05832af56d5fc783d77994bea4bbac4.svg";
export { ForwardRef as ReactComponent };